import React, { Component } from 'react'
import { Container, Row, Col, Card, Button, Media } from 'react-bootstrap';
import './EamcetSubPlansSection.scss'
import { withRouter, Link } from "react-router-dom";
import * as Cookies from "es-cookie";
import moment from "moment";
import self_study from '../../../images/self_study.png';



//import ipe_lec from '../../../images/ipe_lec.png';
import {
    BrowserView,
    MobileView,
    isBrowser,
    isMobile
} from "react-device-detect";
import ReactGA from 'react-ga';
import { GoogleAnalyticsArray } from '../../pages/GoogleAnalytics';
import ipe_lec from "../../../images/university-college-school-building-vector.png";

// Plan card icons. The image_path the API sends (static_content_images/*.png)
// no longer resolves, so each card gets an icon badge instead, in the page's
// own gradients.
const PLAN_ICONS = [
    { icon: "fas fa-book-reader", background: "linear-gradient(135deg, #06BEB6 0%, #48B1BF 100%)" },
    { icon: "fas fa-user-graduate", background: "linear-gradient(135deg, #CC2B5E 0%, #753A88 100%)" },
    { icon: "fas fa-university", background: "linear-gradient(135deg, #BB2CFF 0%, #6A11CB 100%)" },
    { icon: "fas fa-chalkboard-teacher", background: "linear-gradient(135deg, #F7971E 0%, #F15A29 100%)" },
];

const TEAL = "linear-gradient(135deg, #06BEB6 0%, #48B1BF 100%)";
const BERRY = "linear-gradient(135deg, #CC2B5E 0%, #753A88 100%)";

// Header colour per plan: the self-study plans (44, 61) teal, the rest berry.
function planGradient(planId) {
    return planId == "44" || planId == "61" ? TEAL : BERRY;
}

// additional_text is sometimes just punctuation (a lone "."); show it only
// when it says something.
function hasText(value) {
    return !!value && /[a-z0-9]/i.test(value);
}

class EamcetPlansHomeSection extends Component {
    constructor(props) {
        super(props)

        this.state = {
            planDetails: '',
            selectedPlanId: '',
        }
    }

    paymentFun = (data) => {
        console.log("data", data)
        this.props.history.push({
            pathname: "/student/subscribe-plans-order-summary",
            state: {
                data: data
            }
        })
    };

    componentDidMount = () => {
        const title = GoogleAnalyticsArray[0].Eamcet_Plans;
        ReactGA.pageview('/student/plans_section', ["rizee"], title);
    }

    getSubPlanDetails = (planDetails, planNameActiveCls) => {
        this.setState(state => ({ ...state, planDetails: planDetails }));
        this.state.selectedPlanId = planNameActiveCls
    }

    render() {

        const getSubscriptionPlans = this.props.getSubscriptionPlans;


        if (this.state.planDetails == "") {
            if (this.props.history.location.state == undefined || (this.props.history.location.state || {}).activePlan == undefined) {
                this.state.selectedPlanId = getSubscriptionPlans[0].id;
            } else {
                this.state.selectedPlanId = (this.props.history.location.state || {}).activePlan;
            }

            if (getSubscriptionPlans != undefined) {
                getSubscriptionPlans.map((defaultPlan, index) => {
                    if (defaultPlan.id == this.state.selectedPlanId) {
                        this.state.planDetails = defaultPlan;
                    }
                });
            }
        }

        return (
            <Container className={isMobile == true ? "plan-eamcet-package mt-5" : "plan-eamcet-package"}>
                <Row>
                    <Col sm={12} className="mt-4">
                        <h3 className="font-weight-bold">Learning Plans</h3>
                        <p className="">Choose your plan to continue learning with Rizee</p>
                    </Col>
                </Row>

                <Row>
                    {
                        getSubscriptionPlans && getSubscriptionPlans.map((planDetails, index) => {
                            const planIcon = PLAN_ICONS[index % PLAN_ICONS.length];
                            return (
                                <Col sm={6} className="mt-4" onClick={() => this.getSubPlanDetails(planDetails, planDetails.id)}>
                                    <Card className={this.state.selectedPlanId == planDetails.id ? "white_block active active_icon" : "white_block"}>
                                        <Card.Body>
                                            <div className="d-flex align-items-center mt-2">
                                                <Card.Subtitle>
                                                    <span className="plan-icon" style={{ background: planIcon.background }}>
                                                        <i className={planIcon.icon} />
                                                    </span>
                                                </Card.Subtitle>
                                                <Card.Title className="ml-2">
                                                    <h5>{planDetails.name}</h5>
                                                    <p className="f-14 color_yash text-capitalize">{planDetails.description}</p>
                                                </Card.Title>
                                            </div>
                                        </Card.Body>
                                    </Card>
                                </Col>
                            )
                        })
                    }
                </Row>

                <Row className="plan-cards">
                    {
                        this.state?.planDetails && this.state.planDetails.studentPlans.map(row => {
                            const gradient = planGradient(row.id);
                            const features = row.plan_features.split("#").map(f => f.trim()).filter(f => f != "");

                            const currentime = moment().unix();
                            const hasExpiry = row.expiry_date != "";
                            const isCurrent = hasExpiry && currentime < row.expiry_date;
                            const days = Math.floor(parseInt(row.expiry_date - currentime) / (24 * 60 * 60));

                            const discounted = row.original_amount != row.amount && parseFloat(row.original_amount) > parseFloat(row.amount);
                            const savePct = discounted ? Math.round((1 - row.amount / row.original_amount) * 100) : 0;

                            return (
                                <Col xl={4} lg={6} md={6} sm={12} className="mt-4 d-flex" key={row.id}>
                                    <div className={"plan-card" + (isCurrent ? " plan-card--current" : "")}>
                                        <div className="plan-card__head" style={{ background: gradient }}>
                                            <span className="plan-card__name">{row.plan_name}</span>
                                            {row.plan_title ? (
                                                <span className="plan-card__duration"><i className="far fa-clock mr-1" />{row.plan_title}</span>
                                            ) : null}
                                            {isCurrent ? <span className="plan-card__badge"><i className="fas fa-check-circle mr-1" />Active</span> : null}
                                        </div>

                                        <div className="plan-card__price">
                                            {discounted ? <span className="plan-card__mrp">₹{row.original_amount}</span> : null}
                                            <span className="plan-card__amount"><small>₹</small>{row.amount}</span>
                                            {savePct > 0 ? <span className="plan-card__save">Save {savePct}%</span> : null}
                                        </div>

                                        {features.length > 0 ? (
                                            <ul className="plan-card__features">
                                                {features.map((item, index) => (
                                                    <li key={index}>
                                                        <span className="plan-card__tick" style={{ background: gradient }}><i className="fas fa-check" /></span>
                                                        <span>{item}</span>
                                                    </li>
                                                ))}
                                            </ul>
                                        ) : <div className="flex-grow-1" />}

                                        <div className="plan-card__footer">
                                            {
                                                row.upgrade_access == true ? (
                                                    <Button onClick={() => this.paymentFun(row)} className="plan-card__cta" style={{ background: gradient }}>
                                                        Upgrade for ₹{row.upgrade_amount}
                                                    </Button>
                                                ) : isCurrent ? (
                                                    <Button className="plan-card__cta plan-card__cta--current" disabled>
                                                        <i className="fas fa-check mr-2" />Current Plan
                                                    </Button>
                                                ) : (
                                                    <Button onClick={() => this.paymentFun(row)} className="plan-card__cta" style={{ background: gradient }}>
                                                        Subscribe Now
                                                    </Button>
                                                )
                                            }
                                            {
                                                row.upgrade_access != true && hasExpiry ? (
                                                    <p className={"plan-card__expiry" + (isCurrent ? "" : " plan-card__expiry--past")}>
                                                        <i className="far fa-hourglass-half mr-1" />
                                                        {isCurrent ? (days > 0 ? `Expires in ${days} day${days == 1 ? "" : "s"}` : "Expires today") : "This package has expired"}
                                                    </p>
                                                ) : null
                                            }
                                            {hasText(row.additional_text) ? <p className="plan-card__note">{row.additional_text}</p> : null}
                                        </div>
                                    </div>
                                </Col>
                            )
                        })
                    }
                </Row>
            </Container>
        )
    }

}
export default withRouter(EamcetPlansHomeSection);
